import AuthChecker from "./api/ValidateAuth";
import Topbar from "../scenes/global/Topbar";
import Sidebar from "../scenes/global/Sidebar";
import { YearProvider } from "./yearpicker/YearContext";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";

const Layout = ({ element, showTop, headerTitle, headerSubtitle }) => { 
  // For supplying dynamic header title    
  const { pageName } = useParams()
  let [pageDisplay, setPageDisplay] = useState('')

  useEffect(() => {
    if(pageName !== undefined) setPageDisplay(pageName.replaceAll("_", " "));
  }, [pageName])

  return (
    <AuthChecker>
    <div className="app">
      <YearProvider>
        <Sidebar/>
      </YearProvider> 
        <main id="content" className="content">
            <Topbar showSiteList={showTop} headerTitle={headerTitle === undefined ? pageDisplay : headerTitle} headerSubtitle={headerSubtitle}/>
                { element }
        </main>
    </div>
    </AuthChecker>
  );
};

export default Layout;